import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// material
import { Box, Card, Typography, Stack } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
// utils
import Label from './Label';
import { fCurrency } from '../utils/formatNumber';

// ----------------------------------------------------------------------

const ProductImgStyle = styled('img')({
  top: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute'
});

// ----------------------------------------------------------------------

ShopProductCard.propTypes = {
  product: PropTypes.object
};

export default function ShopProductCard({ product }) {
  const { t } = useTranslation();
  const { title, cover, price, link, status, priceSale, inStock } = product;

  return (
    <Card>
      <Box sx={{ pt: '100%', position: 'relative' }}>
        {status && (
          <Label
            variant="filled"
            color={(status === 'sale' && 'error') || 'info'}
            sx={{
              zIndex: 9,
              top: 16,
              right: 16,
              position: 'absolute',
              textTransform: 'uppercase'
            }}
          >
            {status}
          </Label>
        )}
        {inStock && (
          <Label
            variant="filled"
            color="success"
            sx={{
              zIndex: 9,
              top: 16,
              left: 16,
              position: 'absolute',
              textTransform: 'uppercase',
              fontSize: '0.75rem',
              padding: '2px 8px',
              backgroundColor: '#90EE90', // Light green color
              color: '#006400' // Darker text for contrast
            }}
          >
            {t('products.in_stock')}
          </Label>
        )}
        <ProductImgStyle alt={title} src={cover} />
      </Box>

      <Stack spacing={2} sx={{ p: 3 }}>
        <a
          href={link}
          target="_blank"
          rel="noreferrer"
          style={{
            color: 'black'
          }}
        >
          <Typography variant="subtitle2" noWrap>
            {title}
          </Typography>
        </a>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          {/* <ColorPreview colors={colors} /> */}
          <Typography variant="subtitle1">
            <Typography
              component="span"
              variant="body1"
              sx={{
                color: 'text.disabled',
                textDecoration: 'line-through'
              }}
            >
              {priceSale && fCurrency(priceSale)}
            </Typography>
            &nbsp;
            {price}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
}
